import {
  BLOOM_WHITE,
  BRIGHT_MAGENTA,
  BRIGHT_PURPLE,
  CORAL_PINK,
  DARK_ORANGE,
  LIGHT_BLUE,
  MEDIUM_BLUE,
  MEDIUM_PINK,
  MEDIUM_PURPLE_2,
  MEDIUM_PURPLE_3,
  MINTY_CYAN,
  SOFT_PEACH,
  TURQUOISE,
  VERY_LIGHT_BLUE,
  YELLOW,
} from './HomepageColorConsts'

export type EllipseConfig = {
  animation?: {
    duration: string
    fill?: string[]
    opacity?: number[]
    scaleRx: number[]
    scaleRy: number[]
    translatePath: { x: number; y: number }[]
  }
  cx: number
  cy: number
  fill: string
  id: string
  rx: number
  ry: number
  transform?: string
}

/* eslint-disable sort-keys */
export const ellipseConfig: EllipseConfig[] = [
  {
    id: 'purple-static-1',
    cx: 353.5,
    cy: 175.965,
    rx: 353.5,
    ry: 175.965,
    transform: 'matrix(-1 0 0 1 1512 230.562)',
    fill: BRIGHT_PURPLE,
    animation: {
      duration: '14s',
      // Slow triangular movement
      translatePath: [
        { x: 0, y: 0 },
        { x: 80, y: -60 },
        { x: -80, y: 60 },
        { x: 0, y: 0 },
      ],
      // Pulsing size
      scaleRx: [353.5, 370, 340, 353.5],
      scaleRy: [175.965, 185, 165, 175.965],
      // Opacity breathing
      opacity: [0.8, 0.4, 0.9, 0.8],
    },
  },
  {
    id: 'pink-animated',
    cx: 275,
    cy: 136.596,
    rx: 275,
    ry: 136.596,
    transform: 'matrix(-1 0 0 1 1478 277.088)',
    fill: BRIGHT_MAGENTA,
    animation: {
      duration: '17s',
      translatePath: [
        { x: 0, y: 0 },
        { x: 160, y: -120 },
        { x: -160, y: 120 },
        { x: 0, y: 0 },
      ],
      // Growing and shrinking dramatically
      scaleRx: [275, 330, 240, 275],
      scaleRy: [136.596, 160, 120, 136.596],
      // Fighting for prominence with opacity
      opacity: [0.7, 1, 0.3, 0.7],
      // Color shifting between pink and coral
      fill: [BRIGHT_MAGENTA, CORAL_PINK, MEDIUM_PINK, BRIGHT_MAGENTA],
    },
  },
  {
    id: 'purple-static-2',
    cx: 353.5,
    cy: 175.965,
    rx: 353.5,
    ry: 175.965,
    transform: 'matrix(-1 0 0 1 707 190)',
    fill: BRIGHT_PURPLE,
    animation: {
      duration: '12s',
      translatePath: [
        { x: 0, y: 0 },
        { x: -100, y: 80 },
        { x: 100, y: -80 },
        { x: 0, y: 0 },
      ],
      scaleRx: [353.5, 330, 370, 353.5],
      scaleRy: [175.965, 165, 185, 175.965],
      opacity: [0.6, 0.9, 0.5, 0.6],
    },
  },
  {
    id: 'purple-mid',
    cx: 275,
    cy: 136.596,
    rx: 275,
    ry: 136.596,
    transform: 'matrix(-1 0 0 1 1104 274.702)',
    fill: BRIGHT_PURPLE,
    animation: {
      duration: '15s',
      translatePath: [
        { x: 0, y: 0 },
        { x: 60, y: 60 },
        { x: -60, y: -60 },
        { x: 0, y: 0 },
      ],
      scaleRx: [275, 300, 260, 275],
      scaleRy: [136.596, 150, 130, 136.596],
      opacity: [0.5, 0.8, 0.4, 0.5],
      // Shifting between purple shades
      fill: [BRIGHT_PURPLE, BRIGHT_MAGENTA, MEDIUM_PURPLE_2, BRIGHT_PURPLE],
    },
  },
  {
    id: 'purple-animated-1',
    cx: 250.5,
    cy: 124.667,
    rx: 250.5,
    ry: 124.667,
    transform: 'matrix(-1 0 0 1 1000 200)',
    fill: BRIGHT_MAGENTA,
    animation: {
      duration: '17s',
      translatePath: [
        { x: 0, y: 0 },
        { x: -120, y: 80 },
        { x: 120, y: -80 },
        { x: 0, y: 0 },
      ],
      // Dramatic size changes
      scaleRx: [250.5, 310, 220, 250.5],
      scaleRy: [124.667, 150, 110, 124.667],
      opacity: [0.8, 0.3, 1, 0.8],
      fill: [BRIGHT_MAGENTA, BRIGHT_MAGENTA, MEDIUM_PURPLE_3, BRIGHT_MAGENTA],
    },
  },
  {
    id: 'blue-animated',
    cx: 305,
    cy: 151.509,
    rx: 305,
    ry: 151.509,
    transform: 'matrix(-1 0 0 1 691 273.509)',
    fill: MEDIUM_BLUE,
    animation: {
      duration: '16s',
      translatePath: [
        { x: 0, y: 0 },
        { x: -120, y: 160 },
        { x: 120, y: -160 },
        { x: 0, y: 0 },
      ],
      // Large size variations
      scaleRx: [305, 370, 260, 305],
      scaleRy: [151.509, 180, 130, 151.509],
      opacity: [0.6, 1, 0.4, 0.6],
      // Blue to cyan shifts
      fill: [MEDIUM_BLUE, MEDIUM_BLUE, VERY_LIGHT_BLUE, MEDIUM_BLUE],
    },
  },
  {
    id: 'orange-animated',
    cx: 91,
    cy: 30.4211,
    rx: 91,
    ry: 30.4211,
    transform: 'matrix(-1 0 0 1 1263 395.193)',
    fill: DARK_ORANGE,
    animation: {
      duration: '15s',
      translatePath: [
        { x: 0, y: 0 },
        { x: 200, y: -140 },
        { x: -200, y: 140 },
        { x: 0, y: 0 },
      ],
      // Orange blob growing and shrinking
      scaleRx: [91, 130, 80, 91],
      scaleRy: [30.4211, 45, 25, 30.4211],
      opacity: [0.9, 0.5, 1, 0.9],
      // Orange to yellow-orange
      fill: [DARK_ORANGE, YELLOW, DARK_ORANGE, DARK_ORANGE],
    },
  },
  {
    id: 'orange-2',
    cx: 91,
    cy: 30.4211,
    rx: 91,
    ry: 30.4211,
    transform: 'matrix(-1 0 0 1 1263 383.263)',
    fill: DARK_ORANGE,
    animation: {
      duration: '13s',
      translatePath: [
        { x: 0, y: 0 },
        { x: -120, y: 80 },
        { x: 120, y: -80 },
        { x: 0, y: 0 },
      ],
      scaleRx: [91, 105, 85, 91],
      scaleRy: [30.4211, 35, 28, 30.4211],
      opacity: [0.7, 0.9, 0.5, 0.7],
    },
  },
  {
    id: 'turquoise-animated',
    cx: 250,
    cy: 150,
    rx: 250,
    ry: 150,
    transform: 'matrix(-1 0 0 1 1317 416.667)',
    fill: TURQUOISE,
    animation: {
      duration: '7s',
      translatePath: [
        { x: 0, y: 0 },
        { x: -180, y: 140 },
        { x: 140, y: -100 },
        { x: 0, y: 0 },
      ],
      scaleRx: [250, 320, 200, 250],
      scaleRy: [150, 190, 120, 150],
      opacity: [0.6, 0.9, 0.4, 0.6],
    },
  },
  {
    id: 'white-bloom-centre',
    cx: 400,
    cy: 250,
    rx: 500,
    ry: 300,
    transform: 'matrix(1 0 0 1 0 0)',
    fill: BLOOM_WHITE,
    animation: {
      duration: '18s',
      translatePath: [
        { x: 0, y: 0 },
        { x: 15, y: -25 },
        { x: -15, y: 25 },
        { x: 0, y: 0 },
      ],
      scaleRx: [500, 520, 480, 500],
      scaleRy: [300, 315, 285, 300],
      opacity: [0.35, 0.55, 0.25, 0.35],
    },
  },
  {
    id: 'peach-top-right',
    cx: 350,
    cy: 180,
    rx: 350,
    ry: 180,
    transform: 'matrix(1 0 0 1 925 -60)',
    fill: SOFT_PEACH,
    animation: {
      duration: '15s',
      translatePath: [
        { x: 0, y: 0 },
        { x: 25, y: 20 },
        { x: -20, y: -15 },
        { x: 0, y: 0 },
      ],
      scaleRx: [350, 390, 310, 350],
      scaleRy: [180, 200, 160, 180],
      opacity: [0.25, 0.45, 0.2, 0.25],
      fill: [SOFT_PEACH, CORAL_PINK, SOFT_PEACH, SOFT_PEACH],
    },
  },
  {
    id: 'yellow-spark-top',
    cx: 150,
    cy: 75,
    rx: 150,
    ry: 75,
    transform: 'matrix(1 0 0 1 500 -90)',
    fill: YELLOW,
    animation: {
      duration: '12s',
      translatePath: [
        { x: 0, y: 0 },
        { x: -20, y: 10 },
        { x: 20, y: -10 },
        { x: 0, y: 0 },
      ],
      scaleRx: [150, 165, 140, 150],
      scaleRy: [75, 82, 68, 75],
      opacity: [0.15, 0.35, 0.1, 0.15],
    },
  },
  {
    id: 'cyan-wash-bottom-left',
    cx: 420,
    cy: 220,
    rx: 420,
    ry: 220,
    transform: 'matrix(1 0 0 1 -200 220)',
    fill: MINTY_CYAN,
    animation: {
      duration: '17s',
      translatePath: [
        { x: 0, y: 0 },
        { x: -35, y: 30 },
        { x: 35, y: -25 },
        { x: 0, y: 0 },
      ],
      scaleRx: [420, 470, 370, 420],
      scaleRy: [220, 250, 190, 220],
      opacity: [0.25, 0.5, 0.2, 0.25],
    },
  },
  {
    id: 'blue-wash-left',
    cx: 420,
    cy: 220,
    rx: 420,
    ry: 220,
    transform: 'matrix(1 0 0 1 -350 100)',
    fill: LIGHT_BLUE,
    animation: {
      duration: '20s',
      translatePath: [
        { x: 0, y: 0 },
        { x: 40, y: -30 },
        { x: -40, y: 30 },
        { x: 0, y: 0 },
      ],
      scaleRx: [420, 470, 370, 420],
      scaleRy: [220, 250, 190, 220],
      opacity: [0.18, 0.32, 0.12, 0.18],
    },
  },
]
